module.exports = __webpack_public_path__ + "static/media/question-solid-full-white.d1fd5107.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/question-solid-full-white.svg
// module id = 375
// module chunks = 0